var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"accent"},on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t('logout')))])}
var staticRenderFns = []

export { render, staticRenderFns }